import moment from "moment-timezone";
import BaseViewController from "./base-view-controller";
import { camelToSnakeCase } from "../utils/case-utils";

class AdvanceMedicalDashboardViewController extends BaseViewController {
  preprocessScreenData() {
    if (!this.screen.showClildScreen) {
      const advanceMedicalHomeScreen = this.appData.data.screens.find(
        screen => screen.identifier === "AdvanceMedicalHome"
      );
      if (advanceMedicalHomeScreen) {
        const generalMedicalVisits =
          advanceMedicalHomeScreen.childScreens.filter(childScreen =>
            childScreen.identifier.includes("MyTeladoc.UpcomingConsult")
          );
        if (generalMedicalVisits.length) {
          generalMedicalVisits.forEach(generalMedicalVisit => {
            const { tabs } = generalMedicalVisit.fields.find(
              field => field.type === "tabBar"
            ).data;
            if (tabs.length) {
              // if consult is NOT completed
              const cancelParamsInSnakeCase = Object.keys(
                generalMedicalVisit.hiddenFields
              )
                .map(
                  key =>
                    `${camelToSnakeCase(key)}=${encodeURIComponent(
                      generalMedicalVisit.hiddenFields[key]
                    )}`
                )
                .join("&");
              const cancelUrl = tabs.find(
                tab => tab.name === "cancelButton"
              ).url;
              this.screen.fields = [
                ...generalMedicalVisit.fields,
                {
                  ...tabs.find(tab => tab.name === "cancelButton"),
                  type: "button",
                  name: "button",
                  links: [
                    {
                      url: `${cancelUrl}${
                        cancelUrl.includes("?") ? "&" : "?"
                      }${cancelParamsInSnakeCase}`
                    }
                  ]
                },
                { type: "divider", name: "divider" },
                ...this.screen.fields
              ];
            } else {
              this.screen.fields = [
                ...generalMedicalVisit.fields,
                { type: "divider", name: "divider" },
                ...this.screen.fields
              ];
            }
          });
        }
      }
      this.screen.showClildScreen = true;
    }
    this.screen.fields = this.screen.fields.map(field => {
      if (
        field.name === "when" &&
        /^\d{2}:\d{2} \/ \d{2}-\d{2}-\d{4}/.test(field.text)
      ) {
        return {
          ...field,
          text: moment(field.text, "hh:mm / DD-MM-YYYY").format(
            "HH:mm dddd, MM-DD-YYYY"
          )
        };
      }
      if (field.name === "start_video") {
        // TODO: add some logic to disable button depends on time
        return { ...field, disabled: false };
      }
      if (field.name === "dashboard_header" && field.image) {
        return { ...field, url: field.image, size: field.text, image: null };
      }
      if (field.name?.includes("consult_message")) {
        return { ...field, name: "status" };
      }
      return field;
    });
  }
}

export default AdvanceMedicalDashboardViewController;
